import http from "../http-common"; 

class DeploymentServerService {
  getAllDeploymentServers(searchDTO) {
    console.log(searchDTO)
    return this.getRequest(`/deploymentServer/deploymentServers`, searchDTO);
  }
 

  get(deploymentServerId) {
    return this.getRequest(`/deploymentServer/${deploymentServerId}`, null);
  }

  findByField(matchData) {
    return this.getRequest(`/deploymentServer?field=${matchData}`, null);
  }

  addDeploymentServer(data) {
    return http.post("/deploymentServer/addDeploymentServer", data);
  }

  update(data) {
  	return http.post("/deploymentServer/updateDeploymentServer", data);
  }
  
  uploadImage(data,deploymentServerId) {
  	return http.postForm("/deploymentServer/uploadImage/"+deploymentServerId, data);
  }




	postRequest(url, data) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.post(url, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
      };

	getRequest(url, params) {
        const token = localStorage.getItem('authToken');
        if (token) {
            return http.get(url, {
            	params: params,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
        }
    };


}

export default new DeploymentServerService();
